<div class="footer">
    <div class="row">
        <div class="col-md-3">
            <a href="https://marihub.net/terms-and-conditions" target="_blank">Terms & Conditions</a>
        </div>
        <div class="col-md-6 text-center">
            <p>
                All rights reserved to Marihub Operating Company FZE DMCC © {{year}}
            </p>
        </div>
        <div class="col-md-3 social">
            <a *ngFor="let link of socialMediaLinks" [href]="link.link" target="_blank">
                <i [class]="'fa-brands ' + link.iconPath"></i>
            </a>
        </div>
    </div>
</div>
